import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Star, MapPin, Users, Home as HomeIcon } from 'lucide-react';
import heroImage from '../assets/bg-home.jpeg';

const Home = () => {
  return (
    <div className="relative overflow-x-hidden">
      <section className="relative h-[100vh] md:h-[90vh] w-full overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-1000 hover:scale-105"
          style={{ 
            backgroundImage: `url(${heroImage})` 
          }}
        >
          <div className="absolute inset-0 bg-black/50 md:bg-black/40"></div>
        </div>

        <div className="relative h-full flex flex-col justify-center items-center text-center px-6 lg:px-24">
          <div className="flex items-center space-x-2 mb-4 animate-fade-in">
            <Star className="text-red-600 fill-red-600" size={14} />
            <span className="text-white uppercase tracking-[0.2em] md:tracking-[0.4em] text-xs md:text-xs font-medium">
              Villa Tengah Pegunungan dan Persawahan
            </span>
            <Star className="text-red-600 fill-red-600" size={14} />
          </div>

          <h1 className="text-4xl md:text-6xl lg:text-8xl font-serif text-white mb-6 leading-tight">
            Kenyamanan <span className="text-red-600">Eksklusif</span> <br className="hidden md:block" /> 
            <span className="italic font-light">di Jantung Alam</span>
          </h1>

          <p className="text-gray-300 text-sm md:text-lg max-w-xl md:max-w-2xl mb-8 md:mb-12 font-light leading-relaxed">
            Rasakan pengalaman menginap tak terlupakan dengan privasi total di lokasi paling strategis dan pemandangan alam memukau.
          </p>

          <div className="flex flex-col sm:flex-row w-full sm:w-auto space-y-4 sm:space-y-0 sm:space-x-4 px-4 sm:px-0">
            <Link 
              to="/booking" 
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 font-bold tracking-widest transition-all text-sm md:text-base flex items-center justify-center group shadow-lg"
            >
              BOOK NOW
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
            </Link>
            
            <Link 
              to="/facilities" 
              className="bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 text-white px-8 py-4 font-bold tracking-widest transition-all text-sm md:text-base"
            >
              OUR FACILITIES
            </Link>
          </div>
        </div>
      </section>

      {/* QUICK INFO BAR - Responsive Grid */}
      <div className="relative z-20 -mt-12 md:-mt-16 px-4 md:px-10 max-w-6xl mx-auto">
        <div className="bg-white p-6 md:p-10 shadow-2xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-0 text-center border-b-8 border-red-600">
          <div className="flex flex-col items-center justify-center md:border-r border-gray-100">
            <MapPin className="text-red-600 mb-2" size={20} />
            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Location</p>
            <p className="font-bold text-gray-800 text-sm md:text-base uppercase">Batulapisi, Malino</p>
          </div>
          <div className="flex flex-col items-center justify-center lg:border-r border-gray-100">
            <Users className="text-red-600 mb-2" size={20} />
            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Capacity</p>
            <p className="font-bold text-gray-800 text-sm md:text-base uppercase">Up to 20 Guests</p>
          </div>
          <div className="flex flex-col items-center justify-center md:border-r border-gray-100">
            <HomeIcon className="text-red-600 mb-2" size={20} />
            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Type</p>
            <p className="font-bold text-gray-800 text-sm md:text-base uppercase">Private Pool</p>
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="flex space-x-1 mb-2">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={12} className="text-red-600 fill-red-600" />
              ))}
            </div>
            <p className="text-[10px] text-gray-400 uppercase tracking-widest">Guest Rating</p>
            <p className="font-bold text-gray-800 text-sm md:text-base uppercase">4.9 / 5.0</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;